<template>
	<v-card>
		<v-toolbar flat color="dark" dark>
			<v-toolbar-title>
				<span class="pl-2" v-if="id > 0">Medewerker sector bewerken</span>
				<span class="pl-2" v-else>Medewerker sector toevoegen</span>
			</v-toolbar-title>
		</v-toolbar>
		<v-card-text>
			<v-alert v-if="formError" type="error" dense outlined class="mb-4">{{ formError }}</v-alert>
			<v-form>
				<v-row>
					<v-col cols="12" sm="6">
						<p class="font-weight-black title">Instructies</p>
						<p class="font-weight-regular">1. Kies het schooljaar.</p>
						<p class="font-weight-regular">2. Kies een werknemer die in het actieve cohort staat.</p>
						<p class="font-weight-regular">3. Kies één of meer sectoren waarin de werknemer actief is.</p>
					</v-col>
					<v-col cols="12" sm="6"></v-col>
					<v-col cols="12" sm="6">
						<p class="font-weight-black title">Registratie</p>
						<v-select
							dense
							:items="schoolyears"
							item-text="name"
							item-value="id"
							v-model="form.schoolyear_id"
							filled
							label="Schoolyear"
						></v-select>
						<v-select
							dense
							:items="employees"
							item-text="teacher_name"
							item-value="id"
							v-model="form.employee_id"
							filled
							label="Employee"
							:no-data-text="employeesLoading ? 'Laden…' : 'Geen actieve werknemers in het cohort.'"
							:loading="employeesLoading"
						></v-select>
						<v-select
							v-if="id > 0"
							dense
							:items="sectors"
							item-text="name"
							item-value="id"
							v-model="form.sector_id"
							filled
							label="Sector"
						></v-select>
						<v-select
							v-else
							dense
							multiple
							chips
							deletable-chips
							:items="sectors"
							item-text="name"
							item-value="id"
							v-model="form.sector_ids"
							filled
							label="Sectoren"
						></v-select>
						<v-checkbox v-if="id > 0" color="red" v-model="form.deleted">
							<template v-slot:label>
								<div><strong class="error--text">Delete</strong></div>
							</template>
						</v-checkbox>
					</v-col>
				</v-row>
			</v-form>
		</v-card-text>
		<v-card-actions>
			<v-btn color="primary" @click="submitForm()" depressed :loading="saving">Save</v-btn>
			<v-btn color="dark" @click="$router.go(-1);" depressed>Cancel</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import Axios from "axios";
import { API_ROOT } from "../../config";

const ax = Axios.create({
	baseURL: API_ROOT["osbod_salary"],
	timeout: 60000
});

export default {
	name: "employeesectoredit",
	props: ["id"],
	data() {
		return {
			user: JSON.parse(localStorage.getItem("user")),
			formError: "",
			saving: false,
			employeesLoading: false,
			schoolyears: [],
			employees: [],
			sectors: [],
			form: {
				id: 0,
				schoolyear_id: null,
				employee_id: null,
				sector_id: null,
				sector_ids: [],
				deleted: null,
				deleted_by_id: null
			}
		};
	},
	created: function() {
		this.getSchoolyears();
		this.getSectors();
		if (this.id > 0) {
			this.getEmployeeSector(this.id);
		}
	},
	watch: {
		"form.schoolyear_id": function(value) {
			if (value) {
				this.getEmployees(value);
			} else {
				this.employees = [];
			}
		}
	},
	methods: {
		getSchoolyears: function() {
			var self = this;
			ax.get("/schoolyear/all").then(function(response) {
				self.schoolyears = response.data;
				if (!self.id && !self.form.schoolyear_id && self.schoolyears.length) {
					self.form.schoolyear_id = self.schoolyears[0].id;
				}
			});
		},
		getSectors: function() {
			var self = this;
			ax.get("/sector/all_administration").then(function(response) {
				self.sectors = response.data;
			});
		},
		getEmployees: function(schoolyearId) {
			var self = this;
			this.employeesLoading = true;
			ax.get("/employee_sector/employees", {
				params: { schoolyear_id: schoolyearId }
			}).then(function(response) {
				self.employees = (response.data || []).map(function(emp) {
					return Object.assign({}, emp, {
						teacher_name: emp.teacher_name || [emp.firstname, emp.surname].filter(Boolean).join(" ")
					});
				});
				self.employeesLoading = false;
			}).catch(function() {
				self.employees = [];
				self.employeesLoading = false;
			});
		},
		getEmployeeSector: function(id) {
			var self = this;
			ax.get("/employee_sector/single/" + id).then(function(response) {
				self.form = Object.assign({}, self.form, response.data, {
					sector_ids: response.data.sector_id ? [response.data.sector_id] : []
				});
			});
		},
		submitForm() {
			var self = this;
			this.formError = "";

			if (!this.form.schoolyear_id || !this.form.employee_id) {
				this.formError = "Kies een schooljaar en een werknemer.";
				return;
			}

			if (this.id > 0 && !this.form.sector_id) {
				this.formError = "Kies een sector.";
				return;
			}

			if (!(this.id > 0) && (!this.form.sector_ids || !this.form.sector_ids.length)) {
				this.formError = "Kies minstens één sector.";
				return;
			}

			this.saving = true;
			if (this.form.deleted) {
				this.form.deleted_by_id = this.user && this.user.id ? this.user.id : this.form.deleted_by_id;
			}

			if (this.form.id > 0) {
				ax.post("/employee_sector/update/" + this.form.id, this.form).then(function() {
					self.saving = false;
					self.$router.push({
						path: "/schooladmin/employee_sector"
					});
				}).catch(function() {
					self.saving = false;
					self.formError = "Opslaan is niet gelukt.";
				});
			} else {
				ax.post("/employee_sector/create", this.form).then(function() {
					self.saving = false;
					self.$router.push({
						path: "/schooladmin/employee_sector"
					});
				}).catch(function() {
					self.saving = false;
					self.formError = "Opslaan is niet gelukt.";
				});
			}
		}
	}
};
</script>
